import { DocsTocGroup } from '../types';
import { getDocsRouteFromDocPath } from '../utils';

export const RELEASE_NOTES_API_LIST: string[] = [
  '3.4.0',
  '3.3.2',
  '3.3.1',
  '3.3.0',
  '3.2.0',
  '3.1.0',
  '3.0.0',
];

export const RELEASE_NOTES_NAVIGATE_PATHS: Record<string, string> = {
  '3.4.0': '/docs/release-notes/3.4.0.md',
  '3.3.2': '/docs/release-notes/3.3.2.md',
  '3.3.1': '/docs/release-notes/3.3.1.md',
  '3.3.0': '/docs/release-notes/3.3.0.md',
  '3.2.0': '/docs/release-notes/3.2.0.md',
  '3.1.0': '/docs/release-notes/3.1.0.md',
  '3.0.0': '/docs/release-notes/3.0.0.md',
};

export const RELEASE_NOTES_TABLE_OF_CONTENTS: DocsTocGroup[] = [
  {
    heading: 'Release Notes APIs',
    items: RELEASE_NOTES_API_LIST.map(apiName => {
      const docPath = RELEASE_NOTES_NAVIGATE_PATHS[apiName];
      const route = docPath
        ? getDocsRouteFromDocPath(docPath, 'release-notes')
        : undefined;
      return { label: apiName, route };
    }),
  },
];
